import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import {
  MobileDetectService,
  RouterService,
  SideMenuService,
  utilsFactory
} from '@lib/gc-common';

@Component({
  selector: 'mip-network',
  templateUrl: './network.component.html',
  styleUrls: ['./network.component.scss'],
})
export class NetworkComponent implements OnInit, AfterViewInit, OnDestroy {
  
  @ViewChild('networkContainer') networkContainer: ElementRef;
  @ViewChild('drawer') sidenav: MatSidenav;
  
  isBrowser = true;
  isDesktop = false;
  isMobile = true;
  
  networkContainerEl = null;
  isInstagramBrowser = false;
  menuBarSettings = { theme: 'dark' };
  isWithinWebView = false;
  isFloatingTransparentMenu = true;
  hideMenuBar = false;
  
  onRouteChangeSubscription = null;
  
  constructor(
    private mobileDetectService: MobileDetectService,
    private routerService: RouterService,
    private sideMenuService: SideMenuService
  ) {
    
    this.isBrowser = utilsFactory.isBrowser;
    this.isMobile = this.mobileDetectService.isMobile();
    this.isDesktop = !this.mobileDetectService.isMobile();
    this.isInstagramBrowser = this.mobileDetectService.isBrowserName('instagram');
    
    this.onRouteChangeSubscription = this.routerService.onRouteChange().subscribe(({ url, data }) => {
      console.log('network.component->constructor(): onRouteChange(): { url, data }', { url, data });
      
      this.isFloatingTransparentMenu = url.indexOf('/trending') === 0 || url.indexOf('/following') === 0;
      console.log('network.component->constructor(): onRouteChange(): this.isFloatingTransparentMenu', this.isFloatingTransparentMenu);
      
      if (data.hideMenuBar) {
        this.hideMenuBar = true;
        this.isFloatingTransparentMenu = true;
      }
      else if (data.menuBarSettings) {
        this.menuBarSettings = data.menuBarSettings;
        console.log('network.component->constructor(): onRouteChange(): this.menuBarSettings', this.menuBarSettings);
        
        if (this.menuBarSettings.theme === 'dark') {
          this.isFloatingTransparentMenu = true;
        }
      }
      else {
        this.menuBarSettings = null;
      }
      
    });
    
  }
  
  async ngOnInit() {
    
    const { queryParams } = await this.routerService.getRouteObject();
    // console.log('network.component->ngOnInit(): routeParams', {queryParams});
    
    this.isWithinWebView = queryParams.isWithinWebView === 'true';
    
  }
  
  ngAfterViewInit() {
    this.sideMenuService.registerSidenav(this.sidenav);
    // console.log('network.component->ngAfterViewInit(): this.sidenav', this.sidenav);
    
    this.networkContainerEl = this.networkContainer.nativeElement;
    
    if (this.isInstagramBrowser && utilsFactory.isBrowser) {
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      // console.log('network.component->ngAfterViewInit(): window.screen', width, height);
      // console.log('network.component->ngAfterViewInit(): window.inner', window.innerWidth, window.innerHeight);
      // console.log('network.component->ngAfterViewInit(): window.client', document.documentElement.clientWidth, document.documentElement.clientHeight);
      this.networkContainerEl.style.width = `${width}px`;
      this.networkContainerEl.style.height = `${height}px`;
    }
  }
  
  ngOnDestroy() {
    this.onRouteChangeSubscription.unsubscribe();
  }
  
}
